import { render, staticRenderFns } from "./versionColorsMobile.vue?vue&type=template&id=763829ba&"
import script from "./versionColorsMobile.vue?vue&type=script&lang=js&"
export * from "./versionColorsMobile.vue?vue&type=script&lang=js&"
import style0 from "./versionColorsMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports